<div class="row gx-3 align-items-center justify-content-between mb-2 mb-md-3" role="listitem">
  <div class="col" [ngClass]="{ 'col-below-408-12': !isReadOnly() }">
    <ng-content select="[slot='left']" />
  </div>
  <div class="col text-end" [ngClass]="{ 'col-below-408-12': !isReadOnly() }">
    <ng-content select="[slot='right']" />
  </div>
</div>
